import { useEffect, useRef } from 'react';
import { consumeConfirmLeaveBypass } from './confirmLeavePageBypass';

const DEFAULT_MESSAGE =
	'Are you sure you want to leave this page? Your progress may be lost.';

const CONFIRM_STATE_KEY = '__confirm_browser_back__';

export function useConfirmOnBrowserBack(enabled: boolean, message?: string) {
	const messageRef = useRef(message);
	const hasPushedStateRef = useRef(false);

	useEffect(() => {
		messageRef.current = message;
	}, [message]);

	useEffect(() => {
		if (!enabled) return;

		if (!hasPushedStateRef.current) {
			window.history.pushState(
				{ [CONFIRM_STATE_KEY]: true },
				'',
				window.location.href
			);
			hasPushedStateRef.current = true;
		}

		const onPopState = () => {
			if (consumeConfirmLeaveBypass()) {
				window.removeEventListener('popstate', onPopState);
				window.history.back();
				return;
			}

			const promptMessage = messageRef.current ?? DEFAULT_MESSAGE;
			const shouldLeave = window.confirm(promptMessage);

			if (shouldLeave) {
				window.removeEventListener('popstate', onPopState);
				window.history.back();
				return;
			}

			window.history.pushState(
				{ [CONFIRM_STATE_KEY]: true },
				'',
				window.location.href
			);
		};

		window.addEventListener('popstate', onPopState);
		return () => window.removeEventListener('popstate', onPopState);
	}, [enabled]);
}
